import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

import { ExternalUserStateMapActions, InternalUserStateMapActions } from './status-map.actions';
import { StatusMapInterface } from '../../../definitions/interfaces/replenishment-process/status-map.interface';
import { ReplenishmentStatusesService } from '../../../services/replenishment-statuses/replenishment-statuses.service';
import { replenishmentStarted } from '../user-configs/user-configs.actions';

@Injectable()
export class StatusMapEffects {
  private actions$ = inject(Actions);
  private replenishmentStatusesService = inject(ReplenishmentStatusesService);

  public loadExternalStatusMap$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(replenishmentStarted),
      switchMap(() =>
        this.replenishmentStatusesService.loadExternalUserStatusMap().pipe(
          map((response: Array<StatusMapInterface>) => ExternalUserStateMapActions.loadSuccess({ states: response })),
          catchError((error: HttpErrorResponse) => of(ExternalUserStateMapActions.loadFailure({ error: error.message }))
          ))
      )
    );
  });

  public loadInternalStatusMap$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(replenishmentStarted),
      switchMap(() =>
        this.replenishmentStatusesService.loadInternalUserStatusMap().pipe(
          map((response: Array<StatusMapInterface>) => InternalUserStateMapActions.loadSuccess({ states: response })),
          catchError((error: HttpErrorResponse) => of(InternalUserStateMapActions.loadFailure({ error: error.message }))
          ))
      )
    );
  });
}
